module.exports = __webpack_public_path__ + "media/images/logo-54acf708.png";